
import { Component, Vue } from "vue-property-decorator";

@Component({
  watch: {
    windowWidth(newWidth, oldWidth) {
      if (oldWidth > 992 && newWidth < 992) {
        (this as any).limit = 1;
      } else if (oldWidth < 992 && newWidth > 992) {
        (this as any).limit = 5;
      }
    },
    dashboardData(newVal, oldVal) {
      (this as any).monthSummary = {
        solicitud: {
          ...(this as any).monthSummary.solicitud,
          value: newVal.header.pendingRequests,
          width: {
            width: `${newVal.header.pendingRequests *
              (100 / newVal.header.requestsCount)}%`
          }
        },
        endoso: {
          ...(this as any).monthSummary.endoso,
          value: newVal.header.pendingEndorsementWithoutMovements,
          width: {
            width: `${newVal.header.pendingEndorsementWithoutMovements *
              (100 / newVal.header.requestsCount)}%`
          }
        },
        endosoMov: {
          ...(this as any).monthSummary.endosoMov,
          value: newVal.header.pendingEndorsementWithMovements,
          width: {
            width: `${newVal.header.pendingEndorsementWithMovements *
              (100 / newVal.header.requestsCount)}%`
          }
        },
        siniestro: {
          ...(this as any).monthSummary.siniestro,
          value: newVal.header.pendingClaims,
          width: {
            width: `${newVal.header.pendingClaims *
              (100 / newVal.header.claimsCount)}%`
          }
        }
      };
    },
    mobileCurrentMonthSummary(newVal, oldVal) {
      switch (newVal) {
        case "solicitud":
          (this as any).filter.modifyType = 0;
          break;
        case "endoso":
          (this as any).filter.modifyType = 1;
          break;
        case "endosoMov":
          (this as any).filter.modifyType = 2;
          break;
        case "siniestro":
          (this as any).filter.modifyType = -1;
      }
    }
  },
  components: {
    Comments: () => import("@/views/client/dashboard/Comments.vue"),
    RequestsGraphs: () => import("@/views/client/dashboard/RequestsGraphs.vue"),
    ClaimsGraphs: () => import("@/views/client/dashboard/ClaimsGraphs.vue"),
    MonthSummary: () => import("@/views/client/dashboard/MonthSummary.vue"),
    Summary: () => import("@/views/client/dashboard/Summary.vue")
  },
  computed: {
    username() {
      return (this as any).$store.state.user.fullname;
    }
  },
  filters: {}
})
export default class Dashboard extends Vue {
  monthSummary: any = {
    solicitud: {
      type: 0,
      value: 0,
      label: "Solicitudes Pendientes",
      width: {}
    },
    endoso: {
      type: 1,
      value: 0,
      label: "Endosos Sin Mov. Pendientes",
      width: {}
    },
    endosoMov: {
      type: 2,
      value: 0,
      label: "Endosos Con Mov. Pendientes",
      width: {}
    },
    siniestro: { type: -1, value: 0, label: "Siniestros Pendientes", width: {} }
  };
  mobileCurrentMonthSummary: string = "solicitud";
  filter: any = {
    controlZoneId: "",
    month: "",
    year: "",
    reporttype: "",
    branchId: "",
    trimester: "",
    status: "",
    code: "",
    requestNumber: "",
    seguredName: "",
    modifyType: 0,
    policy_number: ""
  };
  limit: number = 5;
  requestsOperationsLimit: number = 5;
  claimsOperationsLimit: number = 5;
  commentsLimit: number = 3;
  windowWidth: number = 0;
  dashboardData: any = {};
  ready = false;
  requestsGraphFilters: any = {
    requestsPerBusiness: {
      currency: 1,
      validity: 1,
    },
    requestsPerBranch: {
      currency: 1,
      validity: 1,
    },
    countRequestsPerBranch: {
      currency: 1,
      validity: 1,
    },
  };
  claimsGraphFilters: any = {
    claimsPerBusiness: {
      currency: 1,
      validity: 1,
    },
    claimsPerBranch: {
      currency: 1,
      validity: 1,
    },
    countClaimsPerBranch: {
      currency: 1,
      validity: 1,
    }
  }
  async mounted() {
    if (window.innerWidth < 992) {
      this.limit = 1;
    } else {
      this.limit = 5;
    }
    await this.loadDashboardData();
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  }
  async seeMoreComments() {
    this.commentsLimit = this.commentsLimit + 3;
    await this.loadDashboardData();
  }
  async seeMoreRequestsOperations() {
    this.requestsOperationsLimit = this.requestsOperationsLimit + 5;
    await this.loadDashboardData();
  }
  async seeMoreClaimsOperations() {
    this.claimsOperationsLimit = this.claimsOperationsLimit + 5;
    await this.loadDashboardData();
  }
  async loadDashboardData() {
    const response: any = await (this.$root as any)._post("admins/dashboard", {
      lastCommentsLimit: this.commentsLimit,
      requestsApprovedPerClientLimit: 6,
      requestsOriginalGrossAonPerClientLimit: this.limit,
      requestsOriginalGrossAonPerBranchLimit: this.limit,
      requestsApprovedPerBranchLimit: this.limit,
      requestsLastOperationsLimit: this.requestsOperationsLimit,
      claimsApprovedPerClientLimit: 6,
      claimsApprovedPerBranchLimit: this.limit,
      claimsLastOperationsLimit: this.claimsOperationsLimit,
      clientCompany: this.$store.state.companyId,
      client: true,
      requestsGraphFilters: this.requestsGraphFilters,
      claimsGraphFilters: this.claimsGraphFilters,
    });
    this.dashboardData = response;
  }
  async handleModifyType(modifyType) {
    this.filter.modifyType = modifyType;
  }
  handleMobileCurrentMonthSummary(value) {
    this.mobileCurrentMonthSummary = value;
  }
}
